import { CommonModule } from '@angular/common';
import { Component, input, InputSignal } from '@angular/core';
import { DividerConfig } from 'src/app/core/models/component-configs';

@Component({
  selector: 'app-divider', standalone: true,
  imports: [CommonModule],
  templateUrl: './divider.component.html',
  styleUrl: './divider.component.scss'
})
export class DividerComponent {
  dividerConfig: InputSignal<DividerConfig> = input({} as DividerConfig);

  getStyles() {
    return {
      'background-color': this.dividerConfig().color,
      'height': this.dividerConfig().orientation === 'horizontal' ? this.dividerConfig().thickness : '100%',
      'width': this.dividerConfig().orientation === 'horizontal' ? '100%' : this.dividerConfig().thickness,
    };
  }
}
